import { createFileRoute } from '@tanstack/react-router'
import { RentalApplicationPage } from '../../../components/rentalApplications/RentalApplicationPage'

export const Route = createFileRoute('/$org/rental-applications/$applicationUid')({
  component: RentalApplicationPage,
})
